module.exports = __webpack_public_path__ + "media/video2.b8bcc133.mp4";